import React from "react";
import {
  CardContent,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  CircularProgress
} from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import { StyledCard } from "./styled";

const SearchConfigurationCard = ({
  location,
  onLocationChange,
  radiusMiles,
  onRadiusMilesChange,
  clearExistingData,
  onToggleClearExistingData,
  onFetch,
  isFormValid,
  loading,
  isListening,
  functionTimeout,
  progressCount,
}) => (
  <StyledCard>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Search Configuration
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <TextField
            fullWidth
            label="Location"
            value={location}
            onChange={(e) => onLocationChange(e.target.value)}
            placeholder="e.g., Traverse City, MI or 123 Main St, Ann Arbor, MI"
            helperText="Enter address, city, state, or zipcode"
            sx={{ mb: 2 }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            type="number"
            label="Radius (miles)"
            value={radiusMiles}
            onChange={(e) => onRadiusMilesChange(parseFloat(e.target.value))}
            inputProps={{ min: 0.1, max: 31.1, step: 0.1 }}
            sx={{ mb: 2 }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={clearExistingData}
                onChange={(e) => onToggleClearExistingData(e.target.checked)}
                color="warning"
              />
            }
            label="Clear existing OSM data before fetching new data"
          />
          <Typography variant="body2" color="textSecondary" sx={{ ml: 4, mt: 1 }}>
            This will remove all previously collected OSM data from your account
          </Typography>
        </Grid>
      </Grid>

      <Button
        variant="contained"
        color="primary"
        onClick={onFetch}
        disabled={!isFormValid || loading || isListening}
        startIcon={loading ? <CircularProgress size={20} /> : <LocationOn />}
        fullWidth
        size="large"
      >
        {loading ? (
          functionTimeout
            ? `Processing... (${progressCount} records found)`
            : "Fetching Data..."
        ) : "Fetch OSM Data"}
      </Button>
    </CardContent>
  </StyledCard>
);

export default SearchConfigurationCard;
